import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Client } from '../../../../shared/client/client';
import { ListLigneCommande } from '../../../shared/commande';
import { CommandeService } from '../../../shared/commande.service';

export interface DialogData {
  lod_ligne_commandes: ListLigneCommande[]
  commandeId: string
  currentClient: Client
}

@Component({
  selector: 'app-commande-validate-dialog',
  templateUrl: './commande-validate-dialog.component.html',
  styleUrls: ['./commande-validate-dialog.component.scss']
})
export class CommandeValidateDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<CommandeValidateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    private commandeService: CommandeService
  ) { }

  validate() {
    this.commandeService.validateInventaires(this.data.commandeId).subscribe(data => {
      this.dialogRef.close(data)
    }, error => {
      this.dialogRef.close(null)
    })
  }

  refuse(): void {
    this.dialogRef.close();
  }
}